import React from 'react';
import listQuery from 'graphql/queries/product/PricingAttributeReferenceListQuery.graphql';
import { EntityType, IDropdownOptionRenderer } from '../../../@types/entityTypes';
import { FilterOperation, IFilterInput, IPricingAttributeReference } from '../../schema/p4types';

const PricingAttributeReferenceOptionRenderer: IDropdownOptionRenderer = ({
  option,
}: {
  option: IPricingAttributeReference;
}) => {
  return <span>{option.description}</span>;
};

const PricingAttributeReference: EntityType = {
  type: 'PricingAttributeReference',
  title: 'Pricing Attribute Reference',
  formTitle: 'Pricing Attribute Reference',
  dropdown: {
    query: listQuery,
    valueKey: 'description',
    labelKey: 'description',
    optionRenderer: PricingAttributeReferenceOptionRenderer,
    remoteFilter: true,
    preLoad: true,
    customVariables: ({ rowData, column }): { filters?: Array<IFilterInput> } => {
      if (column) {
        const fieldNamePosition = column.fieldName.lastIndexOf('ttribute') + 8;
        const numericPart = column.fieldName.substring(fieldNamePosition);
        return {
          filters: [
            {
              filterOperation: FilterOperation.Equals,
              filterParameters: {
                field: 'pricingAttributeIndex',
                value: numericPart,
              },
            },
          ],
        };
      }
      return {};
    },
  },
  screenReference: 'PRICING_ATTRIBUTE_REFERENCE', //No screens directly reference this, but should be included anyway.
};

export default PricingAttributeReference;
